import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { SmallTagBase } from '@/components/ui/Tag/SmallTagBase';
const colors = {
    discreet: {
        bgColor: 'bg-gray-300',
        textColor: 'textGray',
    },
    inactive: {
        bgColor: 'bg-blue-gray-100',
        textColor: 'white',
    },
    info: {
        bgColor: 'bg-turquoise-blue-100',
        textColor: 'white',
    },
    negative: {
        bgColor: 'bg-coral-pink-100',
        textColor: 'white',
    },
    none: {
        bgColor: '',
        textColor: 'textGray',
    },
    positive: {
        bgColor: 'bg-turquoise-green-100',
        textColor: 'white',
    },
    primary: {
        bgColor: 'bg-navy-100',
        textColor: 'white',
    },
};
export const SmallTag = (props) => {
    const { children, className = '', color, isKanjiTopFixed, textClassName = '', } = props;
    return (_jsx(SmallTagBase, Object.assign({ className: clsx(colors[color].bgColor, className), isKanjiTopFixed: isKanjiTopFixed, textClassName: textClassName, textColor: colors[color].textColor }, { children: children })));
};
